import Vue from 'vue'
import VueI18n from 'vue-i18n'

import StorageHelper from 'storage-helper'

import messages from './messages'
import router from '@/router'
import store from '@/store'

Vue.use(VueI18n)

const locale = StorageHelper.getItem('locale', false, 'cn')

const i18n = new VueI18n({
  locale,
  messages,
  fallbackLocale: 'cn'
})

router.beforeEach((to, from, next) => {
  if (!from.name) {
    return store.dispatch('setLocale', to.meta.locale).then(next)
  }

  next()
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js